/**
 * This object handle simple common variable
 * shared across all platform
 */
export const environmentCommonVariable = {
  production: false,
  isApp: false,
  //Flag used to differentiate BIGStudio WebApp and Digital Place in order to
  //render the correct pages used in shared-components
  isDigitalPlace: true,
  /**
   * This variable contain the http address used for:
   * * Execute any API call (BIGStudio)
   * * Connect to mqtt/websocket (BIGStudio)
   */
  httpServerRoot: "",
  staticFolderDownload: "/download/",
  apiFolderDownloads: "/downloads/",
  AESSecuretyPrivateKey: "51655468566D5971",
  defaultButtonSupervisionColor: "#EAEAEA",
  defaultButtonSupervisionBorder: "thin solid rgb(146 146 146)",
  imageCustomerStaffDefault: "assets/img/User.png",
  ionicStoreConfig: {
    name: "__bigms3SQL",
    driverOrder: ["sqlite", "indexeddb", "websql", "localstorage"],
  },
  remoteServerLogAddress: "",
  httpDPAPIRoot: "",
  anaciPlatformAuth: "",
  anaciPlatformBuilding: "",
  anaciPlatformProduct: "",
  anaciPlatformUser: "",
  anaciPlatformQuote: "",
  theme: -1,
  wsHostName: "",
  wsPort: "",
  sentryEnv: "development",
  cbid: "",
  httpRequestTimeoutDefault: 20000,
  billAWSFolder: "",
  quoteAWSFolder: "",
  serverEndpoint: "",
  iconRepositoryEndpoint: "",
};
